import { useState, useRef, useMemo } from 'react';
import { throttle } from 'lodash';


export function useOptimizedProgress() {
  const [progress, setProgress] = useState(0);
  const progressRef = useRef(0);
  
  const throttledSetProgress = useMemo(
    () => throttle((value) => {
      if (value !== progressRef.current) {
        progressRef.current = value;
        setProgress(value);
      }
    }, 100),
    []
  );
  
  return [progress, throttledSetProgress];
};